import Repo from './Repo.js'

export default class WarehouseStatesRepository extends Repo {
    constructor () {
        super('warehouse-states')
    }

    search (data) {
        return this.http.get(this.resource + '/search', data).then((response) => {
            return Promise.resolve(response)
        }).catch((response) => {
            return Promise.reject(response)
        })
    }

    searchAndExport (data, name = "Warehouses states") {
        data.export = 1;
        return this.http.download(this.resource + '/search', data).then((response) => {
            let blob = new Blob([response.data], { type:   'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' } );
            let link = document.createElement('a');
            link.href = window.URL.createObjectURL(blob);
            link.download = name+'.xlsx';
            link.click();
            return Promise.resolve(response);
        }).catch((response) => {
            return Promise.reject(response)
        })
    }
}
